import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  cardSpacing: {
    marginTop: 35,
    marginBottom: 35,
  },
  radioSpacing: {
    marginBottom: 'auto',
  },
  infoBackground: {
    background: '#ECEAEA',
  },
}))

export default useStyles
